import { Redirect } from 'react-router';

const SignOut = () => {
    return <Redirect to='/' />;
};

export default SignOut;
